import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { rootReducer } from './reducers';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function createReduxStore(instanceId, additionalPreloadedState = {}) {
    const preloadedState = { instanceId: { instanceId }, ...additionalPreloadedState };
    return configureStore({
        reducer: rootReducer,
        preloadedState
    });
}
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
